import React from 'react';
import HeaderSection from "../headerSection/HeaderSection";

 function HaramLive() {
  return (
    <div>
     <HeaderSection></HeaderSection>
<p>حرم زنده</p>
    </div>
  )
}
export default HaramLive;